import { downloadBlob } from "./downloadBlob";

/** Export the drawing SVG element as a standalone .svg file */
export function downloadSvg(svgElement: SVGSVGElement, filename: string): void {
  const clone = svgElement.cloneNode(true) as SVGSVGElement;
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  clone.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");

  const style = document.createElementNS("http://www.w3.org/2000/svg", "style");
  style.textContent = `
    .drawing-visible-edge { fill: none; stroke: #000; stroke-width: 0.5; stroke-linecap: round; stroke-linejoin: round; }
    .drawing-hidden-edge { fill: none; stroke: #999; stroke-width: 0.25; stroke-dasharray: 4 2; stroke-linecap: round; stroke-linejoin: round; }
    .annotation-dim line, .annotation-dim path { stroke: #000; }
    .annotation-dim text { fill: #000; font-family: monospace; }
    .annotation-centerline line { stroke: #000; }
    .annotation-leader line, .annotation-leader path { stroke: #000; }
    .annotation-balloon circle { fill: none; stroke: #000; }
    .annotation-balloon text { fill: #000; font-family: monospace; }
    .annotation-gdt rect { fill: #fff; stroke: #000; }
    .annotation-gdt text { fill: #000; font-family: monospace; }
    .title-block text { font-family: monospace; }
  `;
  clone.insertBefore(style, clone.firstChild);

  const serializer = new XMLSerializer();
  const svgString = '<?xml version="1.0" encoding="UTF-8"?>\n' + serializer.serializeToString(clone);
  downloadBlob(new Blob([svgString], { type: "image/svg+xml" }), filename);
}
